module.exports = __webpack_public_path__ + "assets/Twitter.793bed83.svg";